import React from 'react';

import './index.sass';


export const SkeletonLoader = ({ className, count }) =>
  <div className={`skeleton-box-wrapper ${className}`}>
    { Array.apply('test', Array(count)).map((elem, index) =>
      <div className={`skeleton-box skeleton-box--${index + 1}`} key={className + index} />
    )}
  </div>;


export const CircleLoader = ({ size, left, top }) => {
  const style = { width: `${size}px`, height: `${size}px`, left: `${left}px`, top: `${top}px` };

  return (
    <div className="circle-loader" style={style} />
  )
};


export const EllipsisLoader = () =>
  <div className="ellipsis-loader">
    <div>
      <span/>
      <span/>
      <span/>
    </div>
  </div>;
